<template>
    <div class="footer">
        <div class="container">
        <footer class="row py-5 mt-5 border-top">
            <div class="col-lg-5 col-md-12">
                <a href="/" class="d-flex align-items-center mb-3 text-decoration-none ms-3">
                    <img src="../assets/pratima v card -02 1.png" alt="" height="94" width="315" class="p-logo">
                </a>
                <div class="logo-text">
                    <p>Pratima Construction and Consultant is dedicated to delivering reliable and innovative water supply and drainage solutions that empower communities and businesses. With years of experience and a commitment to excellence, we have become a trusted partner in creating sustainable and efficient systems that improve lives. </p>
                </div>
            </div>

            <div class="col-lg-3 mt-4 menu-footer">
                <h5 class="mb-4">Menu</h5>
                <ul class="nav flex-column text-white">
                    <li class="nav-item mb-4"><a href="/" class="nav-link p-0 text-white">Home</a></li>
                    <li class="nav-item mb-4"><a href="/about-us" class="nav-link p-0 text-white">About</a></li>
                    <li class="nav-item mb-4"><a href="/services" class="nav-link p-0 text-white">Services</a></li>
                    <li class="nav-item mb-4"><a href="/projects" class="nav-link p-0 text-white">Projects</a></li>
                    <li class="nav-item mb-4"><a href="/contact-us" class="nav-link p-0 text-white">Contacts</a></li>
                </ul>

            </div>
            <div class="mt-4 social-media-middle">
                <div>
                    <ul class="nav col-12 mt-3 ms-4">
                        <li class="me-4">
                            <img src="@/assets/images/Logo linkedin 1.svg" alt="LinkedIn Logo">
                        </li>
                        <li class="me-4">
                            <img src="@/assets/images/Logo facebook 1.svg" alt="Facebook Logo">
                        </li>
                        <li>
                            <img src="@/assets/images/Logo instagram 1.svg" alt="Instagram Logo">
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-12 mt-4 contact-us">
                <h5 class="mb-4">Contact Us</h5>
                <ul class="nav flex-column">
                    <li class="nav-item mb-1"><a href="#" class="nav-link p-0 text-white">26 Kalash,  Kashiko Nagar, Near </a></li>
                    <li class="nav-item mb-4"><a href="#" class="nav-link p-0 text-white">Bhujbal Farm, Nashik 422009 </a></li>
                    <li class="nav-item mb-4"><a href="#" class="nav-link p-0 text-white">8888034089</a></li>
                    <li class="nav-item mb-1"><a href="#" class="nav-link p-0 text-white">pratimaconstruction19@gmail.com</a></li>
                    <li class="nav-item mb-4"><a href="#" class="nav-link p-0 text-white">sahebraogade@gmail.com</a></li>
                </ul>
            </div>
            <div class="container ">
                <footer>
                    <div class="line"></div>
                    <div class="social-media-bottom">
                        <ul class="nav col-md-4 mt-3">
                            <li class="me-4">
                                <img src="@/assets/images/Logo linkedin 1.svg" alt="LinkedIn Logo">
                            </li>
                            <li class="me-4">
                                <img src="@/assets/images/Logo facebook 1.svg" alt="Facebook Logo">
                            </li>
                            <li>
                                <img src="@/assets/images/Logo instagram 1.svg" alt="Instagram Logo">
                            </li>
                        </ul>
                    </div>
                </footer>
            </div>
        </footer>
        </div>
           
    </div>  
</template>
  
  <script>
 
  </script>
  
  <style scoped>
    .footer{
        background: #031534;
        width: 100%;
        height: auto;
        border-radius: 48px 48px 0px 0px;
        color: white !important;
    }
    .footer .logo-text{
        font-family: 'Inter';
        font-size: 17px;
        font-weight: 400;
        line-height: 27.36px;
        text-align: left;
        padding: 0px 2rem;
    }
    .footer .menu-footer {
        padding: 0px 0rem 0px 10vh;
    }
    .footer .menu-footer h5{
        font-family: 'Archivo';
        font-size: 36px;
        font-weight: 500;
        line-height: 36px;
        text-align: left;
    }

    .footer .menu-footer li{
        font-family: 'Inter';
        font-size: 24px;
        font-weight: 400;
        line-height: 30px;
        text-align: left;
    }
    .footer .contact-us h5{
        font-family: 'Archivo';
        font-size: 36px;
        font-weight: 500;
        line-height: 36px;
        text-align: left;
    }
    .footer .contact-us li{
        font-family: 'Inter';
        font-size: 24px;
        font-weight: 400;
        line-height: 30px;
        text-align: left;

    }
    .footer .line{
        width: auto;
        left: 147px;
        border: 1px solid #565D6D;
        margin-top: 0px;
    }

    .social-media-middle{
        display: none;
    }

    @media (max-width:987px) {
        .menu-footer{
            display: none;
        }
        .social-media-bottom{
            display: none;
        }
        .social-media-middle{
            display: flex;
        }



        .footer .contact-us{
            padding: 0px 5rem 0px 2rem;
            margin-left: 0.5rem !important;
        }
        .footer .contact-us{
            text-align: left;
        }
    }

    @media (max-width:391px) {
        .footer .p-logo{
            height: 110px;
            width: 330px;
        }

        .footer .contact-us h5{
            font-size: 30px;
        }

        .footer .contact-us li{
            font-size: 20px;
        }
        .footer .contact-us{
            padding: 0px 2rem 0px 2rem;
        }

    }


    @media (max-width: 329px) {
        .footer .p-logo{
            height: 110px;
            width: 280px;
        }
        .footer .contact-us{
            padding: 0px 1rem 0px 1rem;
        }
    }


  </style>
  